import script from "./AddQuotationSectionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddQuotationSectionModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddQuotationSectionModal.vue?vue&type=style&index=0&id=5e12c623&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e12c623"]])

export default __exports__